import { render, staticRenderFns } from "./FixedElements.vue?vue&type=template&id=72b82aa7&scoped=true&"
import script from "./FixedElements.vue?vue&type=script&lang=ts&"
export * from "./FixedElements.vue?vue&type=script&lang=ts&"
import style0 from "./FixedElements.vue?vue&type=style&index=0&id=72b82aa7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b82aa7",
  null
  
)

export default component.exports